(() => {
  if (window.eleatBundleFrequencyDropdownInstalled) return;
  window.eleatBundleFrequencyDropdownInstalled = true;
  const controllers = new Map();
  const handles = [4, 6, 8, 10, 12].map(weeks => `${weeks}-weeks`);

  function initialise() {
    document.querySelectorAll('[data-bab-guidance]').forEach(root => {
      if (controllers.has(root)) return;
      const copyNode = root.parentElement.querySelector('[data-bab-frequency-copy]');
      if (!copyNode) return;
      const copy = JSON.parse(copyNode.textContent);
      const cleanup = [];
      root.querySelectorAll('.build-a-bundle__frequency .build-a-bundle__type-subscriptions').forEach((panel, index) => {
        const choices = panel.querySelector('.build-a-bundle__frequency-buttons');
        if (!choices) return;
        const row = document.createElement('div');
        row.className = 'bab-frequency-select-row';
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `bab-frequency-select-${root.querySelector('[data-section-id]')?.dataset.sectionId || 'bundle'}-${index}`;
        label.htmlFor = select.id;
        label.textContent = copy.delivery;
        select.className = 'bab-frequency-select';
        row.append(label, select);
        panel.prepend(row);
        let signature = '';
        const buttons = () => Array.from(choices.querySelectorAll('.build-a-bundle__type-subscription'));
        function sync() {
          const available = buttons();
          const valid = handles.filter(handle => available.some(button => button.dataset.plan === handle && !button.disabled));
          const nextSignature = valid.join(',');
          if (nextSignature !== signature) {
            select.replaceChildren(...valid.map(handle => {
              const option = document.createElement('option');
              option.value = handle;
              option.textContent = copy.everyWeeks.replace('[count]', handle.split('-')[0]);
              return option;
            }));
            signature = nextSignature;
          }
          const selected = available.find(button => button.classList.contains('active'))?.dataset.plan;
          if (selected && valid.includes(selected)) select.value = selected;
          select.disabled = !valid.length;
          panel.classList.toggle('bab-has-frequency-select', valid.length > 0);
          row.hidden = !valid.length;
        }
        function onChange() {
          buttons().find(button => button.dataset.plan === select.value)?.click();
          sync();
        }
        const stopClick = event => event.stopPropagation();
        row.addEventListener('click', stopClick);
        select.addEventListener('change', onChange);
        const observer = new MutationObserver(sync);
        observer.observe(choices, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled', 'data-plan'] });
        sync();
        cleanup.push(() => { observer.disconnect(); row.removeEventListener('click', stopClick); select.removeEventListener('change', onChange); row.remove(); panel.classList.remove('bab-has-frequency-select'); });
      });
      controllers.set(root, () => { cleanup.forEach(destroy => destroy()); controllers.delete(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', event => controllers.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); }));
})();
